import { CoreIcon } from '../core-icon';
import logoutSVG from '../../../src/images/icons/logout.svg';

export const LogoutIcon = props => {
  return <CoreIcon src={logoutSVG} {...props} />;
};
